import styled, { css } from 'styled-components'

import Flex from 'src/components/Layout/Flex/Flex'
import { SectionProps } from './types'

export const Section = styled(Flex).attrs({
  as: 'section',
  flexDirection: 'column',
  alignItems: 'flex-start',
}) <SectionProps>`
    width: 80vw;
    margin: ${props =>
    props.addUpperMargin
      ? '16px 0 0 0'
      : props.removeMargin
        ? 0
        : '24px 0'};
    margin-bottom: ${props => props.addBottomMargin && '24px'};
    padding: ${props =>
    props.addUpperMargin
      ? 0
      : props.removeMargin
        ? 0
        : '24px 0'};
    border-bottom: 1px solid ${props => props.addBottomBorder ? props.theme.colors.shades.neutral[2] : 'transparent'};

    ${props => props.overflowXHidden && css`
      overflow-x: ${props.overflowXHidden};
    `}

    ${props => props.greyBackground && css`
      padding: 24px;
      background-color: ${props => props.theme.colors.shades.neutral[0]};
    `}

    ${props => props.boxSizing && css`
      box-sizing: ${props.boxSizing};
    `}
  `
